import { useCartStore } from '@/stores/CartStore';

export function UpdateCart() {
    const cartStore = useCartStore();
    cartStore.getItems();
}